import { fork } from 'redux-saga/effects';
import Documents from './Documents/redux/sagas';
import DocumentCard from './DocumentsCard/redux/sagas';
export default function* Document() {
  yield fork(Documents);
  yield fork(DocumentCard);
}
